import React from 'react';
import { UserSettings } from '../../types/index';

interface GoogleCalendarCardProps {
  preferences: UserSettings;
  googleCalendars: Array<{ id: string; name: string }>;
  onUpdate?: (preferences: UserSettings) => void;
}

const GoogleCalendarCard: React.FC<GoogleCalendarCardProps> = ({
  preferences,
  googleCalendars,
  onUpdate,
}) => {
  const handleChange = (value: string) => {
    if (onUpdate) {
      onUpdate({
        ...preferences,
        googleCalendarId: value,
      });
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-6">
      <h2 className="text-xl font-semibold text-primary mb-4">Google Calendar</h2>

      <div className="mb-4">
        <label className="block text-primary mb-2">Calendario Predeterminado:</label>
        <select
          className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary/50 disabled:bg-gray-100 disabled:text-gray-400"
          value={preferences.googleCalendarId}
          disabled={!preferences.appointmentsEnabled}
          onChange={(e) => handleChange(e.target.value)}
        >
          <option value="">Seleccionar Calendario</option>
          {googleCalendars.map((calendar) => (
            <option key={calendar.id} value={calendar.id}>
              {calendar.name}
            </option>
          ))}
        </select>
        <p className="text-sm text-gray-500 mt-1">
          Selecciona el calendario principal donde se crearán las citas
        </p>
      </div>
    </div>
  );
};

export default GoogleCalendarCard;
